import { z } from 'zod';

export const coachOverallGradeRankOrder = ['S', 'A', 'B', 'C', 'D', 'Never_Taught', 'Not_reviewed'] as const;
export const coachOverallGradeEnum = z.enum(coachOverallGradeRankOrder);

export const coachOverallGradeSchema = coachOverallGradeEnum.nullable();
